import localforage from "localforage";

// Separate stores for different data types
const lookupsStore = localforage.createInstance({ name: "amp-mineops", storeName: "lookups" });
const reportsStore = localforage.createInstance({ name: "amp-mineops", storeName: "reports" });
const queueStore = localforage.createInstance({ name: "amp-mineops", storeName: "sync_queue" });
const shiftLogsStore = localforage.createInstance({ name: "amp-mineops", storeName: "shift_logs" });

// ======== LOOKUPS CACHE ========
export async function cacheLookups(data) {
  await lookupsStore.setItem("lookups", data);
  await lookupsStore.setItem("lookups_ts", Date.now());
}
export async function getCachedLookups() {
  return lookupsStore.getItem("lookups");
}

// ======== REPORTS CACHE ========
export async function cacheReportsList(reports) {
  await reportsStore.setItem("reports_list", reports);
}
export async function getCachedReportsList() {
  return reportsStore.getItem("reports_list");
}
export async function cacheReport(reportId, data) {
  await reportsStore.setItem(`report_${reportId}`, data);
}
export async function getCachedReport(reportId) {
  return reportsStore.getItem(`report_${reportId}`);
}

// ======== SHIFT LOGS CACHE ========
export async function cacheShiftLogs(reportId, logs) {
  await shiftLogsStore.setItem(`logs_${reportId}`, logs);
}
export async function getCachedShiftLogs(reportId) {
  return shiftLogsStore.getItem(`logs_${reportId}`);
}
export async function appendOfflineLog(reportId, log) {
  const existing = (await shiftLogsStore.getItem(`logs_${reportId}`)) || [];
  existing.push(log);
  await shiftLogsStore.setItem(`logs_${reportId}`, existing);
  return existing;
}
export async function removeOfflineLog(reportId, logId) {
  const existing = (await shiftLogsStore.getItem(`logs_${reportId}`)) || [];
  const filtered = existing.filter((l) => l.id !== logId);
  await shiftLogsStore.setItem(`logs_${reportId}`, filtered);
  return filtered;
}

// ======== SYNC QUEUE ========
export async function getQueue() {
  return (await queueStore.getItem("queue")) || [];
}
export async function addToQueue(item) {
  const queue = await getQueue();
  queue.push({ ...item, queued_at: Date.now(), status: "pending" });
  await queueStore.setItem("queue", queue);
  return queue;
}
export async function removeFromQueue(itemId) {
  const queue = await getQueue();
  const filtered = queue.filter((q) => q.id !== itemId);
  await queueStore.setItem("queue", filtered);
  return filtered;
}
export async function clearQueue() {
  await queueStore.setItem("queue", []);
}
export async function updateQueueItem(itemId, updates) {
  const queue = await getQueue();
  const idx = queue.findIndex((q) => q.id === itemId);
  if (idx >= 0) queue[idx] = { ...queue[idx], ...updates };
  await queueStore.setItem("queue", queue);
  return queue;
}

// ======== OFFLINE REPORTS ========
export async function saveOfflineReport(report) {
  const existing = (await reportsStore.getItem("offline_reports")) || [];
  existing.push(report);
  await reportsStore.setItem("offline_reports", existing);
  return existing;
}
export async function getOfflineReports() {
  return (await reportsStore.getItem("offline_reports")) || [];
}
export async function removeOfflineReport(tempId) {
  const existing = (await reportsStore.getItem("offline_reports")) || [];
  const filtered = existing.filter((r) => r.id !== tempId);
  await reportsStore.setItem("offline_reports", filtered);
  return filtered;
}
export async function remapOfflineReportId(tempId, realId) {
  // Update the shift logs store key
  const logs = await shiftLogsStore.getItem(`logs_${tempId}`);
  if (logs) {
    const remapped = logs.map((l) => ({ ...l, report_id: realId }));
    await shiftLogsStore.setItem(`logs_${realId}`, remapped);
    await shiftLogsStore.removeItem(`logs_${tempId}`);
  }
  // Update queue items
  const queue = await getQueue();
  const updated = queue.map((q) =>
    q.reportId === tempId ? { ...q, reportId: realId, payload: { ...q.payload, report_id: realId } } : q
  );
  await queueStore.setItem("queue", updated);
}

// ======== UTILITY ========
export function generateOfflineId() {
  return `offline_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
export function isOfflineId(id) {
  return typeof id === "string" && id.startsWith("offline_");
}
